import styled from "styled-components"
import { maxWidth, minWidth, eq } from "utils"

export const ProductLayout = styled.section`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "flex")};
  align-items: center;
  position: relative;
  background-color: ${(props) => props.theme.component.background};

  * {
    line-height: 1.35;
  }

  > * {
    max-width: 50%;
    flex: 0 0 50%;
  }

  ${maxWidth.hamburgerLarge`
    flex-direction: column;
    align-items: flex-start;

    > * {
      max-width: 100%;
      flex: 1 0 auto;
    }
  `}
`

export const Left = styled.div`
  align-self: flex-start;

  ${maxWidth.hamburgerLarge`
    width: 100%;
  `}

  ${eq("variant", "class")`
    ${minWidth.desktop`
      padding-top: 4rem;
    `}
  `}

  ${eq("variant", "product")`
    ${minWidth.hamburgerLarge`
      padding-top: 6.2rem;
    `}
  `}
`

export const Right = styled.div`
  align-self: stretch;
  position: relative;

  ${eq("variant", "class")`
    padding: 4rem 6rem;

    ${maxWidth.mobile`
      padding: 2.5rem;
    `}
  `}

  ${eq("variant", "product")`
    padding: 3.4rem 2rem 3.4rem 2.9rem;

    ${minWidth.hamburgerLarge`
      padding: 6.2rem 7.2rem 6.2rem;
    `}
  `}

  ${maxWidth.tablet`
    order: 1;
  `}
`
